"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var DesktopLevels_1 = __importDefault(require("./DesktopLevels"));
var MobileLevels_1 = __importDefault(require("./MobileLevels"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Levels = function (_a) {
    var data = _a.data, level = _a.level;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var t = (0, next_intl_1.useTranslations)('translation');
    if (!level || !data)
        return null;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("p", { className: styles_module_scss_1.default.levels }, t('loyaltyVipClubLevels')),
        Object.keys(breakpoints).length > 0 && !breakpoints.mobile ? (react_1.default.createElement(DesktopLevels_1.default, { data: data, level: level })) : (react_1.default.createElement(MobileLevels_1.default, { data: data, level: level }))));
};
exports.default = Levels;
